export class GcpSqlVmBackupSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "maxTransferSizeBytes",
            "baseName": "maxTransferSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "logBackupIntervalMinutes",
            "baseName": "logBackupIntervalMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "fullBackupTime",
            "baseName": "fullBackupTime",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpSqlVmBackupSettings.attributeTypeMap;
    }
    constructor() {
    }
}
